import { useState } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import CanonicalTag from '../components/CanonicalTag';
import petGroomingImage from '../assets/pet-grooming-adu.jpg';

const HowToUseADUPetGrooming = () => {
  const [showCalendly, setShowCalendly] = useState(false);

  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);
  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/how-to-use-adu-as-pet-grooming-studio" />
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="pt-24 pb-16">
          <div className="container mx-auto px-6">
            {/* Hero Section */}
            <div className="text-center mb-16">
              <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
                How to Use Your ADU as a Pet Grooming or Boarding Studio
              </h1>
              <div className="flex justify-center mb-8">
                <button 
                  onClick={openCalendlyModal}
                  className="bg-brand-orange text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-brand-orange/90 transition-colors"
                >
                  📅 Book & Schedule
                </button>
              </div>
            </div>

            {/* Main Image */}
            <div className="mb-16">
              <img 
                src={petGroomingImage} 
                alt="ADU Pet Grooming Studio" 
                className="w-full h-96 object-cover rounded-lg shadow-lg"
              />
            </div>

            {/* Content Sections */}
            <div className="space-y-16">
              {/* Section 1 */}
              <section>
                <h2 className="text-3xl font-bold mb-8" style={{ color: '#E4683B' }}>
                  A Clean, Comfortable Grooming Space in Your Yard
                </h2>
                <p className="text-lg text-muted-foreground mb-8">
                  Create a pet-safe, purpose-built grooming studio or small boarding station using an ADU built to commercial-grade specs.
                </p>
                
                <div className="grid md:grid-cols-3 gap-6 mb-8">
                  <div className="bg-background border border-border rounded-lg p-6">
                    <h3 className="text-xl font-semibold mb-4" style={{ color: '#E4683B' }}>Professional Setup</h3>
                    <p className="text-muted-foreground">Commercial-grade facilities designed specifically for pet care and safety</p>
                  </div>
                  <div className="bg-background border border-border rounded-lg p-6">
                    <h3 className="text-xl font-semibold mb-4" style={{ color: '#E4683B' }}>Multi-Purpose</h3>
                    <p className="text-muted-foreground">Perfect for grooming, boarding, daycare, or specialized pet services</p>
                  </div>
                  <div className="bg-background border border-border rounded-lg p-6">
                    <h3 className="text-xl font-semibold mb-4" style={{ color: '#E4683B' }}>Safety First</h3>
                    <p className="text-muted-foreground">Non-slip surfaces, proper ventilation, and pet-safe materials throughout</p>
                  </div>
                </div>

                <div className="flex flex-col md:flex-row gap-4 justify-center">
                  <button 
                    onClick={() => window.location.href = '/landing'}
                    className="bg-white text-brand-orange border-2 border-brand-orange px-6 py-3 rounded-lg font-semibold hover:bg-brand-orange hover:text-white transition-colors"
                  >
                    📐 What Fits My Lot?
                  </button>
                  <button 
                    onClick={() => window.location.href = '/adu-calculator'}
                    className="bg-brand-orange text-white px-6 py-3 rounded-lg font-semibold hover:bg-brand-orange/90 transition-colors"
                  >
                    💰 Get Your Price & ROI Report
                  </button>
                </div>
              </section>

              {/* Section 2 */}
              <section>
                <h2 className="text-3xl font-bold mb-8" style={{ color: '#E4683B' }}>
                  Ideal For Pet Care Professionals
                </h2>
                <div className="grid md:grid-cols-2 gap-8">
                  <div>
                    <h3 className="text-2xl font-semibold mb-4" style={{ color: '#E4683B' }}>Perfect For:</h3>
                    <ul className="space-y-3 text-muted-foreground">
                      <li>• Independent pet groomers</li>
                      <li>• Dog daycare operators</li>
                      <li>• Traveling or part-time boarding businesses</li>
                      <li>• Mobile grooming base operations</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-2xl font-semibold mb-4" style={{ color: '#E4683B' }}>Functional Design Tips:</h3>
                    <ul className="space-y-3 text-muted-foreground">
                      <li>• Wet zone for wash station with built-in pet tub</li>
                      <li>• Grooming table and supply wall organization</li>
                      <li>• Cubbies or kennels with ventilation</li>
                      <li>• Waterproof, slip-resistant flooring</li>
                    </ul>
                  </div>
                </div>
              </section>

              {/* Section 3 */}
              <section>
                <h2 className="text-3xl font-bold mb-8" style={{ color: '#E4683B' }}>
                  Business Perks
                </h2>
                <p className="text-lg text-muted-foreground mb-8">
                  Sanitization zones with drain-safe plumbing and commercial-grade ventilation for a healthy work environment.
                </p>
                
                <div className="grid md:grid-cols-3 gap-6">
                  <div className="bg-background border border-border rounded-lg p-6">
                    <h3 className="text-xl font-semibold mb-4" style={{ color: '#E4683B' }}>Low Overhead</h3>
                    <p className="text-muted-foreground">High repeat clientele with minimal operating costs and overhead expenses</p>
                  </div>
                  <div className="bg-background border border-border rounded-lg p-6">
                    <h3 className="text-xl font-semibold mb-4" style={{ color: '#E4683B' }}>Property Value</h3>
                    <p className="text-muted-foreground">Add value while supporting a pet-friendly home business model</p>
                  </div>
                  <div className="bg-background border border-border rounded-lg p-6">
                    <h3 className="text-xl font-semibold mb-4" style={{ color: '#E4683B' }}>Income Opportunity</h3>
                    <p className="text-muted-foreground">License or sublease space to other groomers for additional income</p>
                  </div>
                </div>
              </section>
            </div>

            {/* Bottom CTAs */}
            <div className="text-center mt-16">
              <div className="flex flex-col md:flex-row gap-4 justify-center">
                <button 
                  onClick={() => window.open('/our-work', '_blank')}
                  className="bg-white text-brand-orange border-2 border-brand-orange px-6 py-3 rounded-lg font-semibold hover:bg-brand-orange hover:text-white transition-colors"
                >
                  🏡 Our Portfolio
                </button>
                <button 
                  onClick={() => window.open('https://uda-adu.com/faq', '_blank')}
                  className="bg-brand-orange text-white px-6 py-3 rounded-lg font-semibold hover:bg-brand-orange/90 transition-colors"
                >
                  ❓ Our FAQ
                </button>
              </div>
            </div>
          </div>
        </main>

        <Footer />

        {/* Calendly Modal */}
        {showCalendly && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl h-[90vh] m-4">
              <div className="flex justify-between items-center p-4 border-b">
                <h3 className="text-lg font-semibold">Schedule a Consultation</h3>
                <button 
                  onClick={closeCalendlyModal}
                  className="text-gray-500 hover:text-gray-700"
                >
                  ✕
                </button>
              </div>
              <iframe 
                src="https://calendly.com/udaadu"
                width="100%" 
                height="100%" 
                frameBorder="0"
                title="Schedule a meeting"
                className="rounded-b-lg"
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default HowToUseADUPetGrooming;